import React from "react";
import { Link } from "react-router-dom";
import { Cookies } from 'react-cookie-consent';

// Bootstrap-based minimal, subtle EU footer
// Background matches your top navigation (#f0f4fa)
// Clean, compact, unobtrusive

const AppFooter = () => {
  const year = new Date().getFullYear();
  const bg = "#f0f4fa"; // same as top nav
  const textColor = "#5b7db1"; // subtle link/text color

  /**
   * Function to reset the user's cookie consent.
   * This forces the consent banner to show again.
   */
  const resetConsent = () => {
    // 1. Delete the consent cookie
    Cookies.remove('myAwesomeCookieConsent');

    // 2. Reload the page to reset the GA initialization
    window.location.reload();
  };

  return (
    <footer
      className="border-top pt-3 pb-2 app-footer"
      style={{ backgroundColor: bg }}
    >
      <div className="container text-center small" style={{ color: textColor }}>
        <div className="d-flex justify-content-center gap-3 flex-wrap mb-1">
          <Link to="/impressum" className="text-decoration-none" style={{ color: textColor }}>
            Impressum
          </Link>
          <Link to="/datenschutz" className="text-decoration-none" style={{ color: textColor }}>
            Datenschutz
          </Link>
          <Link to="/kontakt" className="text-decoration-none" style={{ color: textColor }}>
            Kontakt
          </Link>
          <button
            onClick={resetConsent}
            className="btn btn-link p-0 text-decoration-none"
            style={{ color: textColor }}
          >
            Cookie-Einstellungen
          </button>
        </div>
        <div className="text-muted" style={{ fontSize: "0.8rem" }}>
          © {year} WeekerAI — Alle Rechte vorbehalten.
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
